
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import api from '@/api/api'
import { saveCredentials } from '@api/connectors/dentalPro'
import { CONNECTOR_TYPES } from '@/vars/general'

const TASKS = [
    {
        title: 'Обратитесь в техническую поддержку DentalPro',
        body: 'Попросите создать нового пользователя для Data Heroes.',
    },
    {
        title: 'Выдайте права',
        body: 'Нужен доступ к API, созданию запросов в техподдержке и просмотру истории обращений.',
    },
    {
        title: 'Заполните логин и пароль',
        body: 'Укажите данные нового пользователя в форме справа.',
    },
]

export default {
    name: 'DentalProAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const loading = ref(false)
        const credentials = ref({
            login: '',
            password: '',
        })

        const btnDisabled = computed(
            () =>
                !String(credentials.value.login || '').trim() ||
                !String(credentials.value.password || '').trim()
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const pendingConnectors = await api.project.getPendingConnectorsByProject({
                projectId,
            })
            const pendingConnector = pendingConnectors.data[0]
            const connector =
                pendingConnector ??
                (await store.dispatch('project/createConnector', {
                    projectId,
                    connectorType: CONNECTOR_TYPES.dentalPro,
                }))
            store.commit('project/setLoggedAddingConnector', connector)
            const { error } = await saveCredentials(connector, credentials.value)
            if (!error) {
                if (pendingConnector) {
                    root.$parent.$emit('next')
                } else {
                    root.$parent.$emit('login')
                }
            }
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Далее',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            credentials,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
